<template>
  <DisputesHistoryComponent :active="true" />
</template>

<script>
import DisputesHistoryComponent from '@/components/DisputesHistoryComponent.vue'

export default {
  name: 'DisputesHistory',
  components: {
    DisputesHistoryComponent
  }
}
</script>
